/* eslint-disable import/no-named-as-default-member */
import { InternationalMarket } from '@chewy/market-handler';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enCA from './locales/ca.json';
import en from './locales/en.json';

// Define available language resources
const resources = {
  [InternationalMarket.enUS]: { translation: en },
  [InternationalMarket.enCA]: { translation: enCA },
};

// Initialize the default i18next instance
// This instance is primarily used for:
// 1. Preloading default translations (US English)
// 2. Providing fallback behavior when market-specific instance fails
// 3. Supporting browser language detection as a fallback mechanism
// Note: The actual translations in the app use createI18nInstance(market)
void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources,
    react: {
      useSuspense: false,
    },
    fallbackLng: InternationalMarket.enUS,
    preload: [InternationalMarket.enUS],
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'path', 'htmlTag'],
      lookupQuerystring: 'lang',
    },
  });

export { i18next as i18n };

/**
 * Creates a new i18n instance for a specific market
 * This is the main instance used throughout the application for:
 * 1. SSR (Server-Side Rendering) to ensure correct language on initial load
 * 2. Preventing language flicker by using market-specific language
 * 3. Test environments where we need isolated i18n instances
 * 4. Components that need market-specific translations

 * @param market - The market code (e.g., InternationalMarketLocale.enUS or InternationalMarketLocale.enCA)
 * @returns A new i18next instance configured for the specified market
 */
export function createI18nInstance(market: string) {
  const lng = market;
  const instance = i18next.createInstance();
  instance.use(initReactI18next).init({
    resources,
    lng,
    fallbackLng: InternationalMarket.enUS,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
  return instance;
}
